var _path, _path2, _path3, _g, _g2, _path4, _path5, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLgSmart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 36,
    viewBox: "0 0 264 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M159.456 21.105L166.489 34.2991H171.088L164.054 20.8463L159.456 21.105Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M173.26 7.3874H183.54V34.2929H187.868V7.3874H198.147V4.54163H173.26V7.3874Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M75.5944 34.8191C82.0866 34.8191 86.1442 31.9733 86.4147 27.5753C86.6852 23.1772 84.2506 20.8489 77.4879 18.2618C71.8073 16.1921 69.9137 14.3812 69.9137 11.7941C69.9137 8.94835 72.6188 7.1374 76.6764 7.1374C79.9225 7.1374 82.6276 7.65482 84.2506 8.43094L85.6032 5.84387C83.1686 4.80904 79.9225 4.29163 75.8649 4.29163C69.3727 4.29163 65.5856 7.65482 65.5856 12.0528C65.5856 16.4509 68.2907 18.7792 74.5123 21.1076C80.193 23.1772 81.8161 24.4708 81.8161 27.3166C81.8161 30.1623 79.111 32.232 74.2418 31.9733C71.8073 31.9733 68.5612 30.9384 66.6676 29.9036L65.3151 32.4907C66.9381 33.2668 70.1842 34.8191 75.5944 34.8191Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.59 4.80725H114.828L106.172 31.4541L97.5153 4.80725H90.7526V34.2999H93.9987V7.13561L102.925 34.2999H108.606L117.262 7.13561V34.2999H117.803L121.59 24.2103V4.80725Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.115 6.61128C166.221 5.31775 163.516 4.54163 160 4.54163H148.909V22.6511L153.237 33.7755V7.3874H159.729C164.869 7.3874 166.492 9.71577 166.492 13.079C166.492 16.7009 164.869 19.2879 158.918 19.2879H154.589V21.875H161.623C167.303 21.875 170.549 17.7357 170.549 13.3377C170.82 10.2332 169.738 7.90482 168.115 6.61128Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M263.335 4.79944H258.736L249.539 29.894L240.071 4.79944H235.202L246.293 34.292H252.244L263.335 4.79944Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M206.26 7.1278H216.81V34.292H222.491V7.1278H233.041V4.79944H206.26V7.1278Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5416 22.9185H44.4928V28.0927C43.4108 28.6101 41.2467 29.1275 39.0827 29.1275C32.5905 29.1275 30.4264 26.023 30.4264 19.5553C30.4264 13.3464 32.5905 9.98318 39.0827 9.98318C42.5993 9.98318 44.7633 11.018 46.3864 13.0877L50.7145 9.20706C48.0094 5.58516 43.1403 4.29163 38.8121 4.29163C28.8033 4.29163 23.3932 9.46577 23.3932 19.5553C23.3932 29.6449 28.2623 34.8191 38.8121 34.8191C43.6813 34.8191 48.2799 33.5255 50.985 31.9733V17.4857H38.5416V22.9185Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70765 4.54944H0.674438V34.3007H22.5856V28.6092H7.70765V4.54944Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.171 15.1542L143.228 12.8259L138.63 0.666626L135.924 6.61689L139.171 15.1542Z",
    fill: "#1999D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.228 12.8229L139.171 15.1512L141.064 19.5493L147.015 22.9125L143.228 12.8229Z",
    fill: "#30BEC2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M136.19 23.1744L138.625 24.9854L136.19 26.5376L147.281 35.075L145.387 30.1595L136.19 23.1744Z",
    fill: "#97C742"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.187 23.1744L125.908 30.4182L124.014 35.075L136.187 26.5376L133.753 24.9854L136.187 23.1744Z",
    fill: "#F68524"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.187 23.1744L133.753 24.9854L136.187 26.5376L138.622 24.9854L136.187 23.1744Z",
    fill: "#9D7230"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.008 22.9126L141.057 19.5494L145.385 30.1564L151.607 35.0719L147.008 22.9126Z",
    fill: "#71C596"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.393 30.1588L147.287 35.0742H151.615L145.393 30.1588Z",
    fill: "#38B24B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.241 20.5807L123.749 24.4613L119.421 35.0683L125.913 30.4116L130.241 20.5807Z",
    fill: "#F15C2A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.421 35.0734H124.019L125.913 30.4166L119.421 35.0734Z",
    fill: "#EF3B25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M135.922 6.61689L133.488 0.666626L128.889 12.3084L132.676 14.3781L135.922 6.61689Z",
    fill: "#6E449B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.892 12.3151L123.753 24.4743L130.245 20.5937L132.679 14.3847L128.892 12.3151Z",
    fill: "#ED174F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M138.623 0.666626H133.483L135.918 6.61689L138.623 0.666626Z",
    fill: "#3C2E46"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLgSmart);
export default __webpack_public_path__ + "static/media/lg-smart.501ce1df7be243b06c27774dd811b3ed.svg";
export { ForwardRef as ReactComponent };